import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '../icon/icon.component';
import { IconName } from '@app/utils/enums/icon-enum';
import { REGEX } from '@app/utils/constants/regex.constants';

@Component({
  selector: 'app-password-hints',
  standalone: true,
  imports: [IconComponent, TranslateModule, NgClass],
  templateUrl: './password-hints.component.html',
  styleUrl: './password-hints.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordHintsComponent {
  public readonly regex = REGEX;
  public readonly iconName = IconName;
  public password = input<string>('');

  public hints = [
    {
      translateKey: 'passwordHintsComponent.minLength',
      test: (value: string) => value.length >= 8,
    },
    {
      translateKey: 'passwordHintsComponent.capitalLetter',
      test: (value: string) => this.regex.passwordHints.capitalLetter.test(value),
    },
    {
      translateKey: 'passwordHintsComponent.lowercaseLetter',
      test: (value: string) => this.regex.passwordHints.lowercaseLetter.test(value),
    },
    {
      translateKey: 'passwordHintsComponent.hasDigit',
      test: (value: string) => this.regex.passwordHints.hasDigit.test(value),
    },
    {
      translateKey: 'passwordHintsComponent.specialLetter',
      test: (value: string) => this.regex.passwordHints.specialLetter.test(value),
    },
  ];
}
